import React from 'react';
import { Link } from 'react-router-dom';
import API from '../../servicios/api';

import listDptos from '../../data/dptos.json';
import listCiudades from '../../data/ciudades.json';
import tipoVivienda from '../../data/vivienda_tipo.json';
import tipoPropVivienda from '../../data/vivienda_propiedad.json';

class Perfil3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            listDptos2: listDptos.tipo,
            listCiudades2: listCiudades.tipo,
            datosCargados:false,
            empleado: [],
            errores: [],
            serverror: ""
         };
    }

    componentDidMount(){
        const keyAPI = this.props.match.params.claveapi; // Se cambio para evitar usuarios curiosos
        fetch(API +"?consultarKeyAPI", {
            method:"POST",
            body: JSON.stringify({claveAPI:keyAPI})
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.length>0 && datos[0].claveAPI){
                // Format some values
                let empleado = datos[0];
                if(empleado.tipopredio==="") empleado.tipopredio="Seleccionar...";
                if(empleado.departamento==="") empleado.departamento="Seleccionar...";
                if(empleado.ciudad==="") empleado.ciudad="Seleccionar...";
                if(empleado.tipovivienda==="") empleado.tipovivienda="Seleccionar...";
                if(empleado.propiedad==="") empleado.propiedad="Seleccionar...";
                if(empleado.deuda==="") empleado.deuda="Seleccionar...";
                empleado.deuda = (empleado.deuda === "1") ? "Si" : "No";
                empleado.animales = (empleado.animales === "1") ? "Si" : "No";
                // empleado.acueducto = (empleado.acueducto === "1") ? "Si" : "No";
                // empleado.alcantarillado = (empleado.alcantarillado === "1") ? "Si" : "No";
                // empleado.electricidad = (empleado.electricidad === "1") ? "Si" : "No";
                // empleado.gas = (empleado.gas === "1") ? "Si" : "No";
                // empleado.telefonia = (empleado.telefonia === "1") ? "Si" : "No";
                // empleado.aseo = (empleado.aseo === "1") ? "Si" : "No";
                // empleado.internet = (empleado.internet === "1") ? "Si" : "No";
                
                this.setState({ 
                    datosCargados:true,
                    empleado: empleado
                });
            } else {
                this.setState({ 
                    datosCargados:true,
                    empleado: []
                });
            }
        })
        .catch(console.log)
    }

    cambioValor = (e) =>{
        const state = this.state.empleado;
        state[e.target.name] = e.target.value;
        // Filtrar ciudades por Dpto
        if (e.target.name==="departamento"){
            let filterCiudades = listCiudades.tipo.filter(o => {
                return o.departamento.toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1
            });
            this.setState({listCiudades2: filterCiudades});
        }
        this.setState( { empleado:state, errores:[], serverror:""});
    }

    verificarError(elm){
        return this.state.errores.indexOf(elm) !== -1;
    }

    enviarDatos = (e) => {
        e.preventDefault();
        let { id, docId, claveAPI,
            tipopredio, departamento,ciudad, barrio, estrato, comuna, 
            direccion, telefono, corregimiento, vereda,
            tipovivienda, propiedad, numhabitaciones, deuda, valordeuda, 
            acueducto, alcantarillado, electricidad, gas, telefonia, aseo, internet,
            animales
        } = this.state.empleado;

        // Validar Errores
        let errores = [];
        if (!docId) errores.push('error_docId');
        if (!tipopredio) errores.push('error_tipopredio');
        if (!departamento) errores.push('error_departamento');
        if (!ciudad) errores.push('error_ciudad');
        // if (!barrio) errores.push('error_barrio');
        // if (!estrato) errores.push('error_estrato');
        // if (!comuna) errores.push('error_comuna');
        if (!direccion) errores.push('error_direccion');
        // if (!telefono) errores.push('error_telefono');
        // if (!corregimiento) errores.push('error_corregimiento');
        // if (!vereda) errores.push('error_vereda');
        if (!tipovivienda) errores.push('error_tipovivienda');
        if (!propiedad) errores.push('error_propiedad');
        // if (!numhabitaciones) errores.push('error_numhabitaciones');
        // if (!deuda) errores.push('error_deuda');
        // if (!valordeuda) errores.push('error_valordeuda');
        
        if(tipopredio==="Seleccionar...") errores.push('error_tipopredio');
        if(departamento==="Seleccionar...") errores.push('error_departamento');
        if(ciudad==="Seleccionar...") errores.push('error_ciudad');
        if(tipovivienda==="Seleccionar...") errores.push('error_tipovivienda');
        if(propiedad==="Seleccionar...") errores.push('error_propiedad');
        if(deuda==="Seleccionar...") errores.push('error_deuda');

        this.setState({errores:errores});
        if (errores.length>0) {
            console.log(errores);
            return false;
        }

        if (barrio===null || barrio===undefined || barrio==="") barrio = "No Aplica";
        if (comuna===null || comuna===undefined || comuna==="") comuna = 0;
        if (estrato===null || estrato===undefined || estrato==="") estrato = 0;
        if (numhabitaciones===null || numhabitaciones===undefined || numhabitaciones==="") numhabitaciones = 0;
        deuda = (deuda.toLocaleLowerCase()==="si" || deuda.toLocaleLowerCase()==="1") ? 1 : 0;
        acueducto = (acueducto.toLocaleLowerCase()==="si" || acueducto.toLocaleLowerCase()==="1") ? 1 : 0;
        alcantarillado = (alcantarillado.toLocaleLowerCase()==="si" || alcantarillado.toLocaleLowerCase()==="1") ? 1 : 0;
        electricidad = (electricidad.toLocaleLowerCase()==="si" || electricidad.toLocaleLowerCase()==="1") ? 1 : 0;
        gas = (gas.toLocaleLowerCase()==="si" || gas.toLocaleLowerCase()==="1") ? 1 : 0;
        telefonia = (telefonia.toLocaleLowerCase()==="si" || telefonia.toLocaleLowerCase()==="1") ? 1 : 0;
        aseo = (aseo.toLocaleLowerCase()==="si" || aseo.toLocaleLowerCase()==="1") ? 1 : 0;
        internet = (internet.toLocaleLowerCase()==="si" || internet.toLocaleLowerCase()==="1") ? 1 : 0;
        animales = (animales.toLocaleLowerCase()==="si" || animales.toLocaleLowerCase()==="1") ? 1 : 0;

        var datosaEnviar = { id:id, claveAPI:claveAPI, docId:docId, 
            tipopredio:tipopredio, departamento:departamento,
            ciudad:ciudad, barrio:barrio, estrato:estrato, comuna:comuna, 
            direccion:direccion, telefono:telefono, corregimiento:corregimiento, vereda:vereda,
            tipovivienda:tipovivienda, propiedad:propiedad, numhabitaciones:numhabitaciones, deuda:deuda, valordeuda:valordeuda, 
            acueducto:acueducto, alcantarillado:alcantarillado, electricidad:electricidad, gas:gas, telefonia:telefonia, aseo:aseo, internet:internet,
            animales:animales
        };
        // console.log(datosaEnviar);
        fetch(API +"?actualizarperfil3=1", {
            method:"POST",
            body: JSON.stringify(datosaEnviar)
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.error && datos.error!==""){
                this.setState({serverror:datos.error});
            } else {
                this.props.history.push("/perfil4/"+datos.claveAPI);
            }
        })
        .catch(console.log)
    }

    filterDepartamento = (e) =>{
        let filter = e.target.value.toUpperCase();
        let listDptos2 = listDptos.tipo.filter(o => {
            return o.name.toUpperCase().indexOf(filter) !== -1
        });
        this.setState({listDptos2: listDptos2});
    }
    filterCiudad = (e) =>{
        let filter = e.target.value.toUpperCase();
        let listCiudades2 = listCiudades.tipo.filter(o => {
            return o.municipio.toUpperCase().indexOf(filter) !== -1
        });
        this.setState({listCiudades2: listCiudades2});
    }

    render() { 

        const { 
            listCiudades2, listDptos2, datosCargados, empleado, serverror
        } = this.state;
        const { 
            docId, claveAPI,
            tipopredio, departamento, corregimiento, vereda, ciudad, barrio, estrato, comuna, 
            direccion, telefono, tipovivienda, propiedad, numhabitaciones, deuda, valordeuda, 
            acueducto, alcantarillado, electricidad, gas, telefonia, aseo, internet,
            animales
        } = empleado;

        if (!datosCargados) {
            return(<div><div className="spinner-border text-success"></div>Cargando datos...</div>);
        } else {
            if (datosCargados && empleado.length===0){
                return (<div>No hay registros</div>);
            } else {
        return ( 
            <div className="card">
                <div className="card-header">
                    <div className='encuesta-title'>
                        <div><strong>PERFIL EMPLEADO</strong></div>
                        <div>3 de 5</div>
                    </div>
                </div>
                <div className="card-body">
                    <form onSubmit={this.enviarDatos}>
                        <div className="form-group oculto">
                            <label htmlFor=""><strong>Número Documento</strong></label>
                            <input readOnly type="text" name="docId" value={docId} onChange={this.cambioValor} id="docId"
                                className={((this.verificarError("error_docId")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Dígite su número de identificación sin espacios, puntos o comas.</small>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Tipo de Predio</strong></label>
                                <div className={((this.verificarError("error_tipopredio")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {tipopredio}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="tipopredio" value="Urbano" className="dropdown-item" type="button">Urbano</button>
                                        <button onClick={this.cambioValor} key={2} name="tipopredio" value="Rural" className="dropdown-item" type="button">Rural</button>
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Departamento</strong></label>
                                {/* <div className={((this.verificarError("error_departamento")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {departamento}
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-longlist" aria-labelledby="dropdownMenu2">
                                        {listDptos.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="departamento" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div> */}
                                <div className={((this.verificarError("error_departamento")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" data-toggle="dropdown">{departamento}
                                        <span className="caret"></span></button>
                                    <ul className="dropdown-menu dropdown-menu-longlist">
                                        <input className="form-control" type="text" placeholder="Buscar..." onKeyUp={this.filterDepartamento} />
                                        {listDptos2.map(e => {
                                            return (
                                                <li key={e.id}><button onClick={this.cambioValor} key={e.id} name="departamento" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>
                        {(tipopredio.toLocaleLowerCase()==="rural")
                        ? 
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Corregimiento</strong></label>
                                <input type="text" id="corregimiento" name="corregimiento" value={corregimiento} onChange={this.cambioValor}
                                    className={((this.verificarError("error_corregimiento")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Vereda</strong></label>
                                <input type="text" id="vereda" name="vereda" value={vereda} onChange={this.cambioValor}
                                    className={((this.verificarError("error_vereda")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>
                        :
                        <></>
                        }

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Ciudad</strong></label>
                                {/* <div className={((this.verificarError("error_ciudad")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {ciudad}
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-longlist" aria-labelledby="dropdownMenu2">
                                        {listCiudades.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="ciudad" value={e.municipio} className="dropdown-item" type="button">{e.municipio}</button>
                                            )
                                        })}
                                    </div>
                                </div> */}
                                <div className={((this.verificarError("error_ciudad")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" data-toggle="dropdown">{ciudad}
                                        <span className="caret"></span></button>
                                    <ul className="dropdown-menu dropdown-menu-longlist">
                                        <input className="form-control" type="text" placeholder="Buscar..." onKeyUp={this.filterCiudad} />
                                        {listCiudades2.map(e => {
                                            return (
                                                <li key={e.id}><button onClick={this.cambioValor} key={e.id} name="ciudad" value={e.municipio} className="dropdown-item" type="button">{e.municipio}</button>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Barrio</strong></label>
                                <input type="text" id="barrio" name="barrio" value={barrio} onChange={this.cambioValor}
                                    className={((this.verificarError("error_barrio")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Estrato</strong></label>
                                <input type="number" id="estrato" name="estrato" value={estrato} onChange={this.cambioValor}
                                    className={((this.verificarError("error_estrato")) ? "is-invalid" : "") + " form-control"} placeholder="0" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Comuna</strong></label>
                                <input type="number" id="comuna" name="comuna" value={comuna} onChange={this.cambioValor}
                                    className={((this.verificarError("error_comuna")) ? "is-invalid" : "") + " form-control"} placeholder="0" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Dirección</strong></label>
                                <input type="text" id="direccion" name="direccion" value={direccion} onChange={this.cambioValor}
                                    className={((this.verificarError("error_direccion")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Teléfono fijo</strong></label>
                                <input type="text" id="telefono" name="telefono" value={(telefono) ? telefono : ""} onChange={this.cambioValor}
                                    className={((this.verificarError("error_telefono")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong># habitaciones</strong></label>
                                {/* value={(numhabitaciones) ? numhabitaciones : 0} */}
                                <input type="number" id="numhabitaciones" name="numhabitaciones" value={numhabitaciones} onChange={this.cambioValor}
                                    className={((this.verificarError("error_numhabitaciones")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Hay Animales?</strong></label>
                                <div className={((this.verificarError("error_animales")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {animales}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="animales" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="animales" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            
                        </div>
                        
                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Tiene Deuda?</strong></label>
                                <div className={((this.verificarError("error_deuda")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {deuda}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="deuda" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="deuda" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Valor deuda</strong></label>
                                <input type="number" id="valordeuda" name="valordeuda" value={(valordeuda) ? valordeuda : 0} onChange={this.cambioValor}
                                    className={((this.verificarError("error_valordeuda")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>Tipo Vivienda</strong></label>
                                <div className={((this.verificarError("error_tipovivienda")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {tipovivienda}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoVivienda.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="tipovivienda" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>Propiedad</strong></label>
                                <div className={((this.verificarError("error_propiedad")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {propiedad}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        {tipoPropVivienda.tipo.map(e => {
                                            return (
                                                <button onClick={this.cambioValor} key={e.id} name="propiedad" value={e.name} className="dropdown-item" type="button">{e.name}</button>
                                            )
                                        })}
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div>

                        {/* <div className="form-group-inline">
                            <div className="form-group separate-input-small">
                                <label htmlFor=""><strong>acueducto</strong></label>
                                <div className={((this.verificarError("error_acueducto")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {acueducto}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="acueducto" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="acueducto" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                            <div className="form-group">
                                <label htmlFor=""><strong>alcantarillado</strong></label>
                                <div className={((this.verificarError("error_alcantarillado")) ? "is-invalid" : "") + " dropdown"} aria-describedby="helpId">
                                    <button className="btn btn-info dropdown-size" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {alcantarillado}
                                    </button>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button onClick={this.cambioValor} key={1} name="alcantarillado" value="Si" className="dropdown-item" type="button">Si</button>
                                        <button onClick={this.cambioValor} key={2} name="alcantarillado" value="No" className="dropdown-item" type="button">No</button>
                                    </div>
                                </div>
                                <small id="helpId" className="invalid-feedback">Registro no válido</small>
                            </div>
                        </div> */}

                        <div className="form-group-inline">
                            <label htmlFor=""><strong>Acueducto</strong></label>
                            <div className={((this.verificarError("error_acueducto")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="acueducto" value="1" defaultChecked={(acueducto === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="acueducto" value="0" defaultChecked={(acueducto === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group-inline">
                            <label htmlFor=""><strong>Alcantarillado</strong></label>
                            <div className={((this.verificarError("error_alcantarillado")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="alcantarillado" value="1" defaultChecked={(alcantarillado === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="alcantarillado" value="0" defaultChecked={(alcantarillado === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>

                        <div className="form-group-inline">
                            <label htmlFor=""><strong>Eléctricidad</strong></label>
                            <div className={((this.verificarError("error_electricidad")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="electricidad" value="1" defaultChecked={(electricidad === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="electricidad" value="0" defaultChecked={(electricidad === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group-inline">
                            <label htmlFor=""><strong>Gas combustible</strong></label>
                            <div className={((this.verificarError("error_gas")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="gas" value="1" defaultChecked={(gas === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="gas" value="0" defaultChecked={(gas === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group-inline">
                            <label htmlFor=""><strong>Telefonía</strong></label>
                            <div className={((this.verificarError("error_telefonia")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="telefonia" value="1" defaultChecked={(telefonia === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="telefonia" value="0" defaultChecked={(telefonia === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group-inline">
                            <label htmlFor=""><strong>Aseo</strong></label>
                            <div className={((this.verificarError("error_aseo")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="aseo" value="1" defaultChecked={(aseo === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="aseo" value="0" defaultChecked={(aseo === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>
                        <div className="form-group-inline">
                            <label htmlFor=""><strong>Internet</strong></label>
                            <div className={((this.verificarError("error_internet")) ? "is-invalid" : "")} aria-describedby="helpId">
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="internet" value="1" defaultChecked={(internet === "1") ? true : false}></input>Si
                                    </label>
                                </div>
                                <div className="form-check-inline">
                                    <label className="form-check-label">
                                        <input type="radio" className="form-check-input" onClick={this.cambioValor} name="internet" value="0" defaultChecked={(internet === "0") ? true : false}></input>No
                                    </label>
                                </div>
                            </div>
                            <small id="helpId" className="invalid-feedback">Registro no válido</small>
                        </div>


                        <div className="server-error">{serverror}</div>

                        <hr width="90%"/>
                        <div className="btn-group btn-acciones" aria-label="">
                            <div className='btn-size-sm'><Link to={"/perfil2/"+claveAPI} className="btn btn-warning btn-size-sm">Atras</Link></div>
                            <div><button type="submit" className="btn btn-success">Siguiente</button></div>
                        </div>
                        
                    </form>
                </div>
                {/* <div className="card-footer text-muted">
                    
                </div> */}
            </div>
        );
            }
        }
    }
}

export default Perfil3;